import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { XType, ScreenSize } from 'src/app/models';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/generic.service';

@Component({
  selector: 'app-occupation-dialog',
  templateUrl: './occupation-dialog.component.html',
  styles: [
  ]
})
export class OccupationDialogComponent implements OnInit {

  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  public rows = [];
  occloading = false;
  size: ScreenSize;

  displayedColumns: string[] = ['name', 'code'];
  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  seletedOccupation: XType;
  constructor(public dialogRef: MatDialogRef<OccupationDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private toastr: ToastrService, private service: GenericService) {
    this.size = service.size;
  }

  ngOnInit(): void {
    this.occloading = true;
    this.service.getData('Generic/GetXTypeList/' + 'Zi1OccupationType').then(response => {
      this.rows = response;
      this.dataSource = new MatTableDataSource(response);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.occloading = false;
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  selectOccupation(item: XType): void {
    this.seletedOccupation = item;
    this.dialogRef.close(item);
  }

  applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

}
